import { makeStyles, createStyles } from "@mui/styles";
import { Theme } from "@mui/material";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleTable: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center", // new
    },
    titleH2: {
      display: "flex",
      paddingLeft: "20px",
    },
    titleH2_1: {
      display: "flex",
      padding: "0px",
    },
    iconTitle: {
      marginTop: "4px",
      marginRight: "5px",
    },
    iconTitle2: {
      marginRight: "5px",
    },
    iconTitle3: {
      marginTop: "-6px",
      marginRight: "5px",
    },
    headOptions: {
      justifyContent: "end",
      marginRight: "5px",
    },
    pnl_type: {
      marginBottom: "10px",
      padding: 0,
    },
    block: {
      padding: "25px 0",
      // padding: "25px",
    },
    paperSpaceList: {
      width: "96%",
      margin: "auto",
      marginTop: "20px",
      padding: "20px",
    },
    validationList: {
      width: "98%",
      margin: "auto",
      marginTop: "20px",
      padding: "20px",
    },
    monthPicker: {
      width: "30%",
      margin: "0 10px",
    },
    accountInfo1: {
      height: "34px",
      display: "flex",
      justifyContent: "flex-end",
      margin: "10px 0",
    },
    accountInfo2: {
      minWidth: "145px",
      display: "flex",
      alignItems: "center",
    },
    accountOptions: {
      display: "flex",
      // margin: "auto",
      marginRight: "0",
      width: "70%",
      justifyContent: "flex-end",
    },
    accountInfo3: {
      display: "flex",
      justifyContent: "space-between",
      width: "80%",
      margin: "16px 0 25px auto",
    },
    buttonAdd: {
      marginLeft: "8% !important",
    },
    aqlDetail: {
      width: "83%",
      margin: "auto",
      marginTop: "20px",
    },
    card_type1: {
      paddingTop: "20px",
      margin: "20px",
      marginTop: "0px",
      width: "-webkit-fill-available",
    },
    card_type2: {
      paddingTop: "20px",
      margin: "20px",
      width: "-webkit-fill-available",
    },
    limitsDetail: {
      width: "100%",
      margin: "auto",
      marginTop: "20px",
    },
    buttonOption: {
      width: "70%",
      color: "#3743aa",
      marginBottom: "10px",
      backgroundColor: "white",
      height: "40px",
      border: "#3743aa solid 1px",
      fontWeight: "bold",
      fontSize: "12px",
      textTransform: "none",
      fontFamily: "Muli, sans-serif",
      marginRight: "1rem",
      "&:hover": {
        border: "1px solid #3743AA",
        backgroundColor: "#3743aa",
        color: "white",
        fontWeight: "bold",
      },
    },
    gridContainer1: {
      display: "flex",
      padding: "0 32px",
      marginTop: "20px",
      marginBottom: "20px",
      marginLeft: "0px",
    },
    gridItem1: {
      padding: "0 32px",
      marginTop: "20px",
      marginBottom: "20px",
    },
    imageRotate: {
      transform: "rotate(90deg) translateY(-100%) scale(1)",
      transformOrigin: "top left",
      width: "55%",
    },
    infoH4: {
      display: "flex",
      width: "30%",
      justifyContent: "space-between",
      paddingBottom: "5px",
    },
  })
);
